"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderConverter = void 0;
const types_1 = require("../../types");
const Order_1 = require("./model/Order");
const OrderItem_1 = require("./model/OrderItem");
const DeliveryMethod_1 = require("../common/model/DeliveryMethod");
class OrderConverter {
    static convertEmbeddedResource(response) {
        return response.data._embedded.orders.map(OrderConverter.convert);
    }
    static convertResource(response) {
        return OrderConverter.convert(response.data);
    }
    static convert(resource) {
        const { id, searchableOrderId, createdAt, updatedAt, _links, totalPrice, status, userDetails, isbnNumber, captionsRequested, items, deliveredAt, deliveryMethod, note, } = resource;
        return {
            id,
            createdAt: new Date(createdAt),
            updatedAt: new Date(updatedAt),
            deliveredAt: deliveredAt ? new Date(deliveredAt) : null,
            deliveryMethod: DeliveryMethod_1.DeliveryMethod[deliveryMethod],
            totalPrice,
            status: Order_1.OrderStatus[status],
            userDetails: {
                authorisingUser: userDetails.authorisingUserLabel,
                requestingUser: userDetails.requestingUserLabel,
                account: userDetails.account,
            },
            note,
            searchableOrderId,
            isbnNumber,
            captionsRequested,
            links: {
                self: new types_1.Link(_links.self),
                update: new types_1.Link(_links.update),
            },
            items: OrderConverter.orderItemsConverter(items),
        };
    }
    static orderItemsConverter(items) {
        return items.map((item) => {
            const { id, channel, licenseDuration, licenseTerritory, warning, price, captionsRequested, transcriptRequested, editRequest, trim, video, issuedLicense, _links, } = item;
            return {
                id,
                channel: channel,
                licenseInfo: {
                    duration: licenseDuration,
                    territory: licenseTerritory,
                    warning: warning,
                },
                price,
                captionsRequested,
                trim,
                transcriptRequested,
                editRequest,
                issuedLicense,
                video: {
                    ...video,
                    captionStatus: OrderItem_1.OrderCaptionStatus[video.captionStatus],
                    _links: {
                        fullProjection: new types_1.Link(video._links.fullProjection),
                        videoUpload: new types_1.Link(video._links.videoUpload),
                        captionAdmin: new types_1.Link(video._links.captionAdmin),
                    },
                },
                links: {
                    markReadyForLicense: _links.markReadyForLicense
                        ? new types_1.Link(_links.markReadyForLicense)
                        : undefined,
                    updatePrice: new types_1.Link(_links.updatePrice),
                    update: new types_1.Link(_links.update),
                },
            };
        });
    }
}
exports.OrderConverter = OrderConverter;
//# sourceMappingURL=OrderConverter.js.map